
import ShopFilter from '../M02-ShopFilter/ShopFilter'

export default {
    name: 'shop-filter',
    data(){
        return {
    
        }
    },

    components: {
        ShopFilter
    }
}